"use client";

import { FREE_SHIPPING_THRESHOLD } from "../../lib/cart-store";

/**
 * Progress toward the free-shipping threshold. Renders nothing while
 * FREE_SHIPPING_THRESHOLD is null (checkout has no free-shipping rule); set the
 * threshold to turn it back on. Rendered only when we have a numeric subtotal — Wix returns the amount as a string and a currency we do
 * not parse, so an unknown subtotal shows nothing rather than a wrong bar.
 */
export default function FreeShippingMeter({ subtotal }: { subtotal: number | null }) {
  if (FREE_SHIPPING_THRESHOLD === null || subtotal === null) return null;

  const remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - subtotal);
  const pct = Math.min(100, Math.round((subtotal / FREE_SHIPPING_THRESHOLD) * 100));
  const qualified = remaining === 0;

  return (
    <div>
      <p className="mb-2 text-[12px] text-ink/70">
        {qualified ? (
          <>Your order ships free.</>
        ) : (
          <>
            <span className="font-medium">${remaining.toFixed(2)}</span> away from free shipping.
          </>
        )}
      </p>
      <div
        className="h-1 w-full bg-mist"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
        aria-label="Progress toward free shipping"
      >
        <div
          className={`h-full transition-[width] duration-500 ${qualified ? "bg-gold-deep" : "bg-ink"}`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
